import * as e from "react";
const d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.912 10.299l-2.83-5.094H7.328L4.498 10.3l7.707 9.836 7.707-9.836zm2.074.767l-9.072 11.58a.885.885 0 01-1.417 0l-9.072-11.58a1.067 1.067 0 01-.087-1.163l3.564-6.416A.916.916 0 016.698 3h11.015c.326 0 .628.185.796.487l3.564 6.416c.204.368.17.835-.087 1.163z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.91 10.727a1 1 0 011-1h16.18a1 1 0 110 2H3.91a1 1 0 01-1-1z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.577 4.115l1.846.77-2.343 5.623 3.848 9.62-1.857.743L6.92 10.492l2.657-6.377z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.423 3.615l-1.846.77 2.343 5.623-3.848 9.62 1.857.743L17.08 9.992l-2.657-6.377z",
      fill: "#2d6ded"
    }
  )
);
export {
  d as default
};
